import React from 'react';
import Page from 'components/page/Page';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Button } from 'common.ui';
import { useTranslation } from 'react-i18next';

interface IProps {
  onLogin: () => void;
}

export const ProfileValidationLogin = ({ onLogin }: IProps) => {
  const { t } = useTranslation('components');
  return (
    <Page
      header={t('profileValidate.profileValidationLogin.title')}
      title={t('profileValidate.profileValidationLogin.title')}
    >
      <Container fluid>
        <Row>
          <Col sm={12} lg={6}>
            <p>{t('profileValidate.profileValidationLogin.text')} </p>
            <Button showArrow text={t('profileValidate.profileValidationLogin.buttonText')} onClick={onLogin} />
          </Col>
        </Row>
      </Container>
    </Page>
  );
};
